import { createAsyncThunk } from "@reduxjs/toolkit";
import { HttpService } from "../../modules/shared/services";
import { CategoryFormSettings, CategoryFormSettingsResponse } from "../../modules/shared/model";

// Fetch category form settings
export const fetchCategoryFormSettings = createAsyncThunk(
  "categoryFormSettings/fetchSettings",
  async (_, { rejectWithValue }) => {
    try {
      const response = await HttpService.get("api/v1/category-form-settings", true);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message || "Failed to fetch category form settings");
    }
  }
);

// Update category form settings
export const updateCategoryFormSettings = createAsyncThunk(
  "categoryFormSettings/updateSettings",
  async ({ id, settings }: { id: string | number; settings: CategoryFormSettings }, { rejectWithValue }) => {
    try {
      const response = await HttpService.patch(`api/v1/category-form-settings/${id}`, settings, {}, true);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message || "Failed to update category form settings");
    }
  }
);

// Create category form settings (if they don't exist)
export const createCategoryFormSettings = createAsyncThunk(
  "categoryFormSettings/createSettings",
  async (settings: CategoryFormSettings, { rejectWithValue }) => {
    try {
      const response = await HttpService.post("api/v1/category-form-settings", settings, {}, true);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message || "Failed to create category form settings");
    }
  }
);

// Fetch latest category form settings
export const fetchLatestCategoryFormSettings = createAsyncThunk(
  "categoryFormSettings/fetchLatestSettings",
  async (_, { rejectWithValue }) => {
    try {
      const response = await HttpService.get("api/v1/category-form-settings/latest", true, {
        "x-custom-lang": "en"
      });
      console.log("response.data", response);
      return response;
    } catch (error: any) {
      return rejectWithValue(error.message || "Failed to fetch latest category form settings");
    }
  }
);
